import _ from 'lodash';
import config from './default';

const test = _.cloneDeep(config);

test.googleAnalyticsCode = 'G-EWSRXD93X2';

export default test;
